// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wsot","footer":"styles_footer__3sXXc","passCodeTooltip":"styles_passCodeTooltip__16CF9"};